import React from 'react';

class Chip extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }
    onChange(value, isSelected) {
        this.props.onChange(value, isSelected);
    }

    render() {
        return (
            <div
                key={this.props.key ? this.props.key : this.props.value}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-100 text-primary-800 rounded-full text-sm font-medium shadow-sm hover:bg-primary-200 transition-colors duration-150"
                title={this.props.label}
            >
                <span className="max-w-32 truncate">{this.props.label}</span>
                <button
                    onClick={() => this.onChange(this.props.value, false)}
                    className="flex-shrink-0 focus:outline-none"
                    aria-label={`Remove ${this.props.label}`}
                    type="button"
                >
                    <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>
            </div>
        );
    }
}

export default Chip;